var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 97,
    viewBox: "0 0 248 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.884155H248V96.8842H0V0.884155Z",
    fill: "#BEF3EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15527e-05 97L248 97V72C248 72 218.939 54.9918 198.437 49.1934C186.431 45.7977 179.505 43.0754 167.031 43.3251C150.725 43.6515 142.638 53.6443 126.5 56C107.171 58.8215 95.6536 59.6321 77 53.8345C47.7413 44.7407 19 0.999985 19 0.999985L0 0.999997L9.15527e-05 97Z",
    fill: "#54DBC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248 0.884155V29.3434C245.622 29.7634 243.116 29.9081 240.868 29.7191C235.484 29.2664 231.175 27.0035 228.354 24.6223C225.555 22.2599 223.79 19.593 221.509 17.0743C219.228 14.5555 216.265 12.0923 211.838 10.6222C204.419 8.15879 194.836 9.03893 186.52 10.4414C178.205 11.844 169.676 13.7139 161.072 12.9698C154.673 12.4162 148.775 10.3505 145.236 7.42359C142.894 5.48699 141.611 3.19337 141.487 0.884155H248Z",
    fill: "url(#paint0_linear_36_42)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_42",
    x1: 248,
    y1: 15.3424,
    x2: 141.487,
    y2: 15.3424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EDBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DD8B4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFresh);
export default __webpack_public_path__ + "static/media/fresh.f3a1aa213910eafdbe382b096b851ae5.svg";
export { ForwardRef as ReactComponent };